import { FC } from "react";
import SalifyFormTextFieldWrapper, {
  SalifyFormTextFieldWrapperProps,
} from "./common/text-field-wrapper";

const SalifyFormTextFieldHidden: FC<SalifyFormTextFieldWrapperProps> = ({
  field,
  textFieldProps,
}) => {
  return (
    <SalifyFormTextFieldWrapper
      field={field}
      textFieldProps={{ ...textFieldProps, hidden: true }}
    />
  );
};

SalifyFormTextFieldHidden.displayName = "SalifyFormTextFieldHidden";

export default SalifyFormTextFieldHidden;
